module.exports = __webpack_public_path__ + "7a0a8145eade34724c02bb5620017ba8.svg";